<template>
  <a-modal
    width="600px"
    title="修改密码"
    v-model:visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form
      class="detail-form"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="账号">
        {{ userInfo.username }}
      </a-form-item>
      <a-form-item label="原密码" name="oldPassword">
        <a-input
          type="password"
          v-model:value="form.oldPassword"
          autocomplete="off">
        </a-input>
      </a-form-item>
      <a-form-item label="验证码" name="code">
        <a-input
          v-model:value="form.code"
          autocomplete="off">
        </a-input>
        <img class="code-img"
          :src="imgUrl"
          alt=""
          @click="getCaptcha">
      </a-form-item>
      <a-form-item label="新密码" name="password">
        <a-input
          type="password"
          v-model:value="form.password"
          autocomplete="off">
        </a-input>
      </a-form-item>
      <a-form-item label="确认新密码" name="repeatPassword">
        <a-input
          type="password"
          v-model:value="form.repeatPassword"
          autocomplete="off">
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import { getCaptcha, login, updatePassword } from '@/api/user'
export default {
  data () {
    const validateRepeatPass = async (_, value) => {
      if (value !== this.form.password) {
        return Promise.reject(new Error('两次密码不一致'))
      } else {
        return Promise.resolve()
      }
    }
    return {
      visible: false,
      form: {
        oldPassword: '',
        code: '',
        password: '',
        repeatPassword: ''
      },
      imgUrl: '',
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        repeatPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validateRepeatPass, trigger: 'blur' }
        ]
      }

    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    open () {
      this.visible = true
      this.getCaptcha()
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    getCaptcha () {
      getCaptcha().then(res => {
        this.imgUrl = URL.createObjectURL(res.data)
      })
    },
    handleSubmit () {
      this.$refs.form.validate().then(() => {
        login({
          username: this.userInfo.username,
          password: this.form.oldPassword,
          code: this.form.code
        }).then(res => {
          const info = res.data
          const accessToken = info.access_token
          localStorage.setItem('westToken', accessToken)
          updatePassword(this.form.password).then(res => {
            this.$message.success('修改成功')
            this.visible = false
          }).catch(err => {
            this.$message.error(err.response.data.message)
          })
        }).catch(err => {
          this.$message.error(err.response.data.message)
        })
      }).catch(e => e)
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>
<style lang="less">

</style>
